<template>
  <vue-content-loading :width="300" :height="$vuetify.breakpoint.smAndDown ? 200 : 100">
    <rect
      :x="$vuetify.breakpoint.smAndDown ? 80 : 20"
      :rx="2"
      :ry="2"
      :height="$vuetify.breakpoint.smAndDown ? 20 : 10"
      :width="$vuetify.breakpoint.smAndDown ? 140 : 88" />

    <rect
      :x="$vuetify.breakpoint.smAndDown ? 90 : 240"
      :y="$vuetify.breakpoint.smAndDown ? 70 : 0"
      :rx="2"
      :ry="2"
      :height="$vuetify.breakpoint.smAndDown ? 10 : 5"
      :width="$vuetify.breakpoint.smAndDown ? 120 : 40" />

    <rect
      :x="$vuetify.breakpoint.smAndDown ? 90 : 20"
      :y="$vuetify.breakpoint.smAndDown ? 30 : 12"
      :rx="2"
      :ry="2"
      :height="$vuetify.breakpoint.smAndDown ? 10 : 5"
      :width="$vuetify.breakpoint.smAndDown ? 120 : 40" />

    <rect
      :x="$vuetify.breakpoint.smAndDown ? 90 : 20"
      :y="$vuetify.breakpoint.smAndDown ? 45 : 25"
      :rx="2"
      :ry="2"
      :height="$vuetify.breakpoint.smAndDown ? 10 : 5"
      :width="$vuetify.breakpoint.smAndDown ? 120 : 50" />

    <rect
      :x="$vuetify.breakpoint.smAndDown ? 80 : 20"
      :y="$vuetify.breakpoint.smAndDown ? 120 : 50"
      :rx="2"
      :ry="2"
      :height="$vuetify.breakpoint.smAndDown ? 20 : 10"
      :width="$vuetify.breakpoint.smAndDown ? 140 : 88" />

    <rect
      :x="$vuetify.breakpoint.smAndDown ? 90 : 240"
      :y="$vuetify.breakpoint.smAndDown ? 190 : 50"
      :rx="2"
      :ry="2"
      :height="$vuetify.breakpoint.smAndDown ? 10 : 5"
      :width="$vuetify.breakpoint.smAndDown ? 120 : 40" />

    <rect
      :x="$vuetify.breakpoint.smAndDown ? 90 : 20"
      :y="$vuetify.breakpoint.smAndDown ? 150 : 62"
      :rx="2"
      :ry="2"
      :height="$vuetify.breakpoint.smAndDown ? 10 : 5"
      :width="$vuetify.breakpoint.smAndDown ? 120 : 40" />

    <rect
      :x="$vuetify.breakpoint.smAndDown ? 90 : 20"
      :y="$vuetify.breakpoint.smAndDown ? 165 : 75"
      :rx="2"
      :ry="2"
      :height="$vuetify.breakpoint.smAndDown ? 10 : 5"
      :width="$vuetify.breakpoint.smAndDown ? 120 : 50" />
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  components: {
    VueContentLoading,
  },
};
</script>
